export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите цель госпитализации ', trigger: 'blur' },
    ],
};
